import { PageFilter, RegularFilter, PageNavigationFilter } from './types';

export function assembleURL(filters: PageFilter[]): URL {
    const url = new URL(window.location.href);
    let newSearchParams = new URLSearchParams();

    for (const filter of filters) {
        if (!isPageNavigationFilter(filter)) {
            newSearchParams.append(filter.query, filter.value);
        } else {
            const [path, query] = filter.value.split('?');
            url.pathname = path;

            if (query) {
                const queryParams = new URLSearchParams(query);
                for (const [key, value] of queryParams.entries()) {
                    newSearchParams.append(key, value);
                }
            }
        }
    }

    url.search = newSearchParams.toString();
    return url;
}

export function isRegularFilter(filter: PageFilter): filter is RegularFilter {
    return !filter.isPageNavigation;
}

export function isPageNavigationFilter(filter: PageFilter): filter is PageNavigationFilter {
    return filter.isPageNavigation;
}
